// src/utils/styles.js
export const appStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

  .stat-card { background: var(--card-bg); border: 1px solid var(--card-border); transition: all 0.2s ease; }
  .stat-card:hover { border-color: var(--card-hover-border); box-shadow: 0 4px 12px var(--card-hover-shadow); transform: translateY(-2px); }
  .project-card { background: var(--card-bg); border: 1px solid var(--card-border); transition: all 0.25s ease; }
  .project-card:hover { border-color: var(--card-hover-border); box-shadow: 0 8px 24px var(--project-card-hover-shadow); transform: translateY(-4px); }
  .nav-item { transition: all 0.15s ease; }
  .nav-item:hover { background: var(--nav-hover); }
  .nav-item.active { background: var(--nav-active-bg); border-left: 3px solid #3b82f6; color: #3b82f6; }
  .nav-item.active .nav-icon { color: #3b82f6; }
  .sidebar { background: var(--sidebar-bg); border-right: 1px solid var(--sidebar-border); }
  .activity-item { transition: all 0.15s ease; border-left: 3px solid transparent; }
  .activity-item:hover { background: var(--row-hover); border-left-color: #3b82f6; }
  .progress-bar { background: var(--progress-track); overflow: hidden; }
  .progress-fill { background: linear-gradient(90deg, #3b82f6 0%, #6366f1 100%); }
  .quick-action { transition: all 0.2s ease; border: 1px solid var(--action-border); }
  .quick-action:hover { border-color: #3b82f6; background: var(--action-hover-bg); }
  .table-row:hover { background: var(--row-hover); }
  .input-field { border: 1px solid var(--input-border); transition: all 0.15s ease; }
  .input-field:focus { border-color: var(--input-focus-border); box-shadow: 0 0 0 3px var(--input-focus-ring); outline: none; }
  .btn-primary { background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%); transition: all 0.2s ease; }
  .btn-primary:hover { background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%); transform: translateY(-1px); box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3); }
  .modal-overlay { background: var(--overlay-bg); backdrop-filter: blur(4px); }
  @keyframes spin { to { transform: rotate(360deg); } }
  .animate-spin { animation: spin 1s linear infinite; }

  /* ── Mobile nav bar ── */
  .mobile-nav { background: var(--mobile-nav-bg); border-top: 1px solid var(--mobile-nav-border); box-shadow: 0 -4px 12px var(--mobile-nav-shadow); }
  .mobile-nav-item { display: flex; flex-direction: column; align-items: center; justify-content: center; flex: 1; padding: 8px 4px 6px; min-height: 56px; transition: color 0.15s ease; color: var(--mobile-nav-inactive); cursor: pointer; border: none; background: none; }
  .mobile-nav-item.active { color: #3b82f6; }
  .mobile-nav-item:active { background: var(--mobile-nav-active-bg); border-radius: 8px; }
  .mobile-nav-label { font-size: 10px; font-weight: 600; margin-top: 3px; line-height: 1; }

  /* ── More drawer ── */
  .more-drawer { position: fixed; left: 0; right: 0; bottom: 0; z-index: 60; background: var(--drawer-bg); border-radius: 20px 20px 0 0; box-shadow: 0 -8px 32px var(--drawer-shadow); transform: translateY(100%); transition: transform 0.3s ease; }
  .more-drawer.open { transform: translateY(0); }
  .more-drawer-overlay { position: fixed; inset: 0; z-index: 55; background: var(--drawer-overlay-bg); }

  /* ── Prevent hover lift effects on touch devices ── */
  @media (hover: none) {
    .stat-card:hover { transform: none; box-shadow: none; border-color: var(--card-border); }
    .project-card:hover { transform: none; box-shadow: none; border-color: var(--card-border); }
    .btn-primary:hover { transform: none; box-shadow: none; }
  }
`;
